export interface InterviewStatus {
  id: number
  session_id: string
  state: InterviewState
  current_question: string | null
  topic: string
  main_questions_asked: number
  total_main_questions: number
  follow_ups_asked_this_main: number
  max_follow_ups_per_main: number
  isDismissed?: boolean
  decision?: boolean
  feedback?: string
}

export enum InterviewState {
  INITIAL = 'INITIAL',
  ASKING_MAIN = 'ASKING_MAIN',
  ASKING_FOLLOWUP = 'ASKING_FOLLOWUP',
  AWAITING_EVALUATION = 'AWAITING_EVALUATION',
  COMPLETED = 'COMPLETED',
}

export interface StartInterview {
  topic: string
  numberOfMainQuestions: number
  numberOfFollowUpQuestions: number
}

export enum AdvisorAvatarType {
  USER = 'user',
  ADVISOR = 'advisor',
}

export type AdvisorMessage = {
  content: string
  role: AdvisorAvatarType
  sources?: string
}
export interface AdvisorConversation {
  id: number
  messages: AdvisorMessage[]
  createdAt: Date
  updatedAt: Date
}

enum AUDIO_STREAM_STATUS {
  SUCCESS = 'success',
  ERROR = 'error',
}
enum AUDIO_STREAM_TYPES {
  START = 'start',
  AUDIO = 'audio',
  AUDIO_DELTA = 'response.audio.delta',
  SEND = 'send',
  DISCARD = 'discard',
}
export const AUDIO_STREAM = {
  types:  AUDIO_STREAM_TYPES,
  status: AUDIO_STREAM_STATUS,
}

